module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak8.fc29d75e.jpg";